module.exports = __webpack_public_path__ + "static/img/contact-modal.154c7af.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contact-modal.svg
// module id = NyMZ
// module chunks = 1